import { 
    useState,
    useEffect, 
    useCallback
} from 'react';
import { 
    Row,
    Col, 
    Card, 
    Form, 
    Button
} from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import moment from 'moment';
import axios from 'axios';

import Registro from './Registro';
import Carregador from '../../Componentes/Carregador';
import FiltroDataCabecalho from '../../Componentes/FiltroDataCabecalho';
import styles from './index.module.scss';
import ModalMaisDetalhes from './ModalMaisDetalhes';

export default function Consultar() {

    // estados
    const [montado, alterarMontado] = useState(false);
    const [carregando, alterarCarregando] = useState(false);
    const [numeroSorte, alterarNumeroSorte] = useState('');
    const [participanteDetalhes, alterarParticipantesDetalhes] = useState(null);
    const [dataFaturamento, alterarDataFaturamento] = useState(moment().format('YYYY-MM-DD'));
    const [participantesSorteados, alterarParticipantesSorteados] = useState([]);
    
    // consulta participantes  
    async function consultarParticipantesPremiados() {
        // ativa carregamento
        alterarCarregando(true);

        try {

            // consulta mandando os parametros necessários
            const { data } = await axios.get('/seguroAventuraParticipante/sorteio', {
                params: {
                    numeroSorteio: numeroSorte,
                    dataFaturamento
                }
            });
            alterarParticipantesSorteados(data.registros);

        } catch (e) {
            console.error(e);
        } finally {
            // desativa o carregamento
            alterarCarregando(false);
        }
    }

    // função para verifica se as variaveis estão de acordo para a liberação da consulta
    const verificaLiberaConsulta = useCallback(() => {
        // verifica as variaveis para liberar a pesquisa
        if (
            numeroSorte &&
            numeroSorte.length === 6 &&
            dataFaturamento
        ) return true;
    }, [numeroSorte, dataFaturamento]);

    useEffect(() => {
        alterarMontado(true);
    }, [])

    // caso não estiver montado, mostra o carregamento
    if (!montado) return (
        <Carregador className="rounded-bottom p-5" />
    )
    
    return (<>
        <Row>
            <Col>
                <Card className="painel-consulta border-0 shadow-sm" >
                    <Card.Header>
                        <div className='d-flex'>
                            <h4 className="card-title font-weight-bolder flex-grow-1">
                                Sorteio
                            </h4>
                        </div>
                        <Row className='mt-3'>
                            <Col lg={'5'}>
                                <Form.Label>Número da sorte</Form.Label>
                                <DebounceInput
                                    placeholder="Ex: 000000"
                                    debounceTimeout={200}
                                    element={Form.Control}
                                    disabled={carregando}
                                    maxLength={6}
                                    value={numeroSorte}
                                    onChange={(e) => {
                                        if (carregando) return;
                                        alterarNumeroSorte(e.target.value);
                                        alterarParticipantesSorteados([]);
                                    }}
                                    style={{ height: 40 }}
                                />
                            </Col>
                            <Col>
                                <Form.Label>Data do faturamento</Form.Label>
                                <div className={styles.containerFiltroDataCabecalho}>
                                    <FiltroDataCabecalho
                                        value={dataFaturamento}
                                        onChange={(novaData) => {
                                            alterarDataFaturamento(novaData);
                                            alterarParticipantesSorteados([]);
                                        }}
                                        periodo={'mensal'}
                                        className={'shadow-none'}
                                        estiloContainer={{
                                            padding: 0,
                                            height: '100%'
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col className='d-flex justify-content-end'>
                                <Button
                                    variant='padrao'
                                    onClick={() => {
                                        if (!verificaLiberaConsulta()) return;
                                        consultarParticipantesPremiados();
                                    }}
                                    style={{ opacity: verificaLiberaConsulta() ? 1 : 0.5 }}
                                >
                                    <span>
                                        Buscar participante(s)
                                    </span>
                                </Button>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        {(participantesSorteados && participantesSorteados.length) > 0 && 
                            <p>
                                {(participantesSorteados.length) === 1 ? 
                                    'Tivemos um participante ganhador! 🥳' :
                                    'Abaixo estão os 5 participantes que estiveram mais próximo do número sorteado'
                                }
                            </p>
                        }
                        <table className="table table-hover tabela">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Número da sorte</th>
                                    <th>Participante</th>
                                    <th>Nasc.</th>
                                    <th>Evento</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {participantesSorteados && participantesSorteados.map((p) => (
                                    <Registro 
                                        key={`${p.dados.id}_${p.dados.numeroSorte}`}
                                        id={p.dados.id}
                                        nome={p.dados.nome}
                                        nomeEvento={p.dadosEvento.nomeEvento}
                                        numeroSorte={p.dados.numeroSorte}
                                        dataNascimento={p.dados.dataNascimento}
                                        clicouVerDetalhes={() => alterarParticipantesDetalhes(p)}
                                    />
                                ))}
                            </tbody>
                        </table>
                        {carregando && <Carregador className="rounded-bottom" />}
                    </Card.Body>
                </Card>
            </Col>
        </Row>

        {participanteDetalhes && (
            <ModalMaisDetalhes 
                dadosParticipante={participanteDetalhes.dados}
                dadosEvento={participanteDetalhes.dadosEvento}
                dadosCliente={participanteDetalhes.dadosCliente}
                aoFechar={() => alterarParticipantesDetalhes(null)}
            />
        )}
    </>)

}